import { render, staticRenderFns } from "./AdministrativeOblasts1946.vue?vue&type=template&id=3035cf2c&"
import script from "./AdministrativeOblasts1946.vue?vue&type=script&lang=js&"
export * from "./AdministrativeOblasts1946.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports